import { MatterStateType } from 'types/matters';

// minimum 1 MatterStateType
const excludeMatters = (stateTypes: [MatterStateType, ...MatterStateType[]]): string => {
    return `matterStateTypeCode=out=(${stateTypes.toString()})`;
};

// minimum 1 MatterStateType
const includeMatters = (stateTypes: [MatterStateType, ...MatterStateType[]]): string => {
    return `matterStateTypeCode=in=(${stateTypes.toString()})`;
};

export const activeCasesFilter = excludeMatters([
    MatterStateType.OFFER_LOST,
    MatterStateType.OFFER_WON,
    MatterStateType.COMPLETED,
]);

const includeInProgressAndOfferPending = includeMatters([MatterStateType.IN_PROGRESS, MatterStateType.OFFER_PENDING]);

export const unblockedClientsFilter = 'id=isunblockedclient=true';

export const canUploadBankTransfers = 'id=canuploadbanktransfers=true';

export const myCasesFilter = 'id=ismycase=true';

// Blocked cases are deliberately included: the timecard and expense pickers list them greyed out and
// non-selectable (see renderMatterOptionWithRestrictedSelection) rather than hiding them.
export const openCasesFilter = includeInProgressAndOfferPending;
